import { useMemo } from 'react';

import ReportCard from 'components/charts/ReportCard';

import useAccessControl from 'hooks/useAccessControl';

import PATHS from 'utils/paths';

import * as S from '../Reports/Reports.styled';

/**
 * @author Burak Ak
 */

const ShipmentReports = () => {
	const isAuthorized = useAccessControl();
	const tabs = useMemo(
		() => [
			{
				title: 'paidCODReports',
				subTitle: 'paidCODReportsSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.PAID_COD
			},
			{
				title: 'deliveryCompanyReportByCity',
				subTitle: 'deliveryCompanyReportByCitySubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.DELIVERY_COMPANY_REPORT_BY_CITY,
				filterArray: [
					{
						label: 'dateInterval',
						component: 'dateInput',
						name: 'date',
						required: true
					}
				]
			},
			{
				title: 'shipmentStatusReport',
				subTitle: 'shipmentStatusReportSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.SHIPMENT_STATUS_REPORT
			},
			{
				title: 'failedDelivery',
				subTitle: 'failedDeliverySubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.FAILED_DELIVERY
			},
			{
				title: 'pickupDeliveryReport',
				subTitle: 'pickupDeliveryReportSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.PICKUP_DELIVERY_REPORT
			},
			{
				title: 'pickupDeliveryReport',
				subTitle: 'pickupDeliveryReportSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.PICKUP_DELIVERY_REPORT_LIST,
				filterArray: [
					{
						label: 'clientName',
						component: 'autoComplete',
						name: 'clientID',
						autoCompleteStringHolder: 'clientName',
						autoCompleteName: 'ALL_CLIENTS',
						selectionLabelAccessor: ['Name'],
						required: true
					}
				]
			},
			{
				title: 'deliveredOrdersByCityByCourier',
				subTitle: 'deliveredOrdersByCityByCourierSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.DELIVERED_ORDERS_BY_CITY_BY_COURIER,
				filterArray: [
					{
						label: 'dateInterval',
						component: 'dateInput',
						name: 'date',
						required: true
					},
					{
						label: 'deliveryCompany',
						component: 'autoComplete',
						name: 'deliveryCompanyID',
						autoCompleteStringHolder: 'deliveryCompanyName',
						autoCompleteName: 'DELIVERY_COMPANY_SETTINGS',
						selectionLabelAccessor: ['Name'],
						required: true
					}
				]
			},
			{
				title: 'deliveryAttemptReport',
				subTitle: 'deliveryAttemptReportSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.DELIVERY_ATTEMPT_REPORT
			},
			{
				title: 'deliveryAttemptReport',
				subTitle: 'deliveryAttemptReportSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.DELIVERY_ATTEMPT_REPORT_FOR_OPERATION,
				filterArray: [
					{
						label: 'createdDate',
						component: 'dateInput',
						name: 'date',
						required: true
					}
				]
			},
			{
				title: 'integratorSLAReport',
				subTitle: 'integratorSLAReportSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.INTEGRATOR_SLA_REPORT
			},
			{
				title: 'aggregatorOTOProfitReport',
				subTitle: 'aggregatorOTOProfitReportSubtitle',
				actionLabel: 'generate',
				actionPath: PATHS.AGGREGATOR_PROFIT_REPORT,
				filterArray: [
					{
						label: 'dateInterval',
						component: 'dateFilter',
						name: 'date',
						required: true
					}
				]
			}
		],
		[]
	);

	return (
		<S.Container className="row row-cols-1 row-cols-lg-2">
			{tabs
				.filter((item) => isAuthorized(item.actionPath))
				.map((item, index) => (
					<ReportCard
						key={index}
						title={item.title}
						subTitle={item.subTitle}
						actionPath={item.actionPath}
						actionLabel={item.actionLabel}
						filterArray={item.filterArray}
					/>
				))}
		</S.Container>
	);
};

export default ShipmentReports;
